import { Component, EventEmitter, Input, Output}    from '@angular/core';

@Component({
  template: require('./transaction-column.component.html')
})
export class TransactionColumnComponent {
  @Input() text: string;
  @Input() record: any;

  @Output() onClick: EventEmitter<any> = new EventEmitter();
}